import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";
import * as HiIcons from "react-icons/hi";
import * as AiIcons from "react-icons/ai";
import * as BsIcons from "react-icons/bs";
import * as GiIcons from "react-icons/gi";
import * as RiIcons from "react-icons/ri";
import * as IoIcons from "react-icons/io";
import * as HeroSolid from "@heroicons/react/24/solid";
import * as HeroOutline from "@heroicons/react/24/outline";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";

const allIcons = {
  ...FaIcons,
  ...MdIcons,
  ...BiIcons,
  ...HiIcons,
  ...AiIcons,
  ...BsIcons,
  ...GiIcons,
  ...RiIcons,
  ...IoIcons,
  ...HeroSolid,
  ...HeroOutline,
};
export const getIconComponent = (iconName: string): React.FC<any> => {
  if (iconName?.startsWith("la-")) {
    return ({ className = "", ...props }) => (
      <i className={`la ${iconName} ${className}`} {...props} />
    );
  }

  const icon = allIcons[iconName as keyof typeof allIcons];

  if (icon) {
    return icon;
  }

  return ({ className = "", ...props }) => (
    <i className={`la la-check-circle ${className}`} {...props} />
  );
};
